import React, { useEffect, useState } from "react";
import NewTitle from "../../extra/Title";
import MultiButton from "../../extra/MultiButton";
import UserProfileSetting from "./UserProfileSetting";
import PasswordSetting from "./PasswordSetting";
import AvatarSetting from "./AvatarSetting";
import { connect, useDispatch, useSelector } from "react-redux";
import Button from "../../extra/Button";
import {
  getUserProfile,
  updatingSubscribersAndUnsubscribers,
} from "../../store/user/user.action";
import { CLOSE_DIALOGUE } from "../../store/dialogue/dialogue.type";
import { useLocation, useNavigate } from "react-router-dom";
import SelectAllTransferList from "../../extra/TransferList";

function UserSubscribed() {
  const [multiButtonSelect, setMultiButtonSelect] = useState("Profile");
  const [subscriber, setSubscriber] = useState([]);
  const [Unsubscriber, setUnsubscriber] = useState([]);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { dialogue, dialogueType, dialogueData } = useSelector(
    (state) => state.dialogue
  );
  const location = useLocation();
  const { userProfile, countryData } = useSelector((state) => state.user);
  const { subscribers, unSubscribers } = useSelector((state) => state.user);

  const [left, setLeft] = React.useState(
    unSubscribers.map((value) => {
      return value.name;
    })
  );
  const [right, setRight] = React.useState(
    subscribers.map((value) => {
      return value.name;
    })
  );

  useEffect(() => {
    setLeft(
      unSubscribers.map((value) => {
        return value.name;
      })
    );
    setRight(
      subscribers.map((value) => {
        return value.name;
      })
    );
  }, [subscribers, unSubscribers]);
  const handleSubmit = () => {
    let resultOfSubscribers = [];
    //getting the subscribers from here
    if (unSubscribers.length != 0) {
      resultOfSubscribers = unSubscribers.filter((user) =>
        right.some((name) => name.toLowerCase() === user.name.toLowerCase())
      );
    }

    //getting the Unsubscribers from here
    let resultOfunSubscribers = [];
    if (subscribers.length != 0) {
      console.log(subscribers.length);
      resultOfunSubscribers = subscribers.filter((user) =>
        left.some((name) => name.toLowerCase() === user.name.toLowerCase())
      );
      console.log(resultOfunSubscribers);
    }

    updatingSubscribersAndUnsubscribers(
      resultOfSubscribers,
      resultOfunSubscribers
    );
  };

  const handleClose = () => {
    if (dialogueData) {
      dispatch({
        type: CLOSE_DIALOGUE,
        payload: {
          dialogue: false,
        },
      });

      let dialogueData_ = {
        dialogue: false,
      };
      localStorage.setItem("dialogueData", JSON.stringify(dialogueData_));
    } else {
      navigate(-1);
    }
  };

  useEffect(() => {
    if (dialogueData) {
      dispatch(getUserProfile(dialogueData?._id));
    } else {
      dispatch(getUserProfile(location?.state?.id));
    }
  }, [dispatch, location?.state?.id]);
  return (
    <div className="userSetting">
      <div className="dashboardHeader primeHeader mb-3 p-0"></div>
      <div className="row">
        <div className="col-4">
          <div className="mb-0 pb-2">
            <NewTitle titleShow={true} name={"User Subscription"} />
          </div>
        </div>
      </div>
      <div className="row">
        <div className="general-setting fake-user video-upload-page mt-3">
          <div className=" userSettingBox">
            <form>
              <div className="row d-flex  align-items-center">
                <div className="col-6">
                  <h5 className="mb-0 text-nowrap">User Subscription</h5>
                </div>
                <div className="col-6 d-flex justify-content-end">
                  <Button
                    btnName={"Back"}
                    newClass={"back-btn"}
                    onClick={handleClose}
                  />
                </div>
                <div
                  className="col-12 d-flex justify-content-end align-items-center"
                  style={{
                    paddingTop: "23px",
                    marginTop: "11px",
                    borderTop: "1px solid #c9c9c9",
                  }}
                ></div>
                <div className="row">
                  <div className="col-12 d-flex justify-content-end align-items-center">
                    <SelectAllTransferList
                      leftLabelName={"Unsubscribed Users"}
                      rightLabelName={"Subscribed Users"}
                      left={left}
                      right={right}
                      setLeft={setLeft}
                      setRight={setRight}
                      subscriber={subscriber}
                      setSubscriber={setSubscriber}
                      Unsubscriber={Unsubscriber}
                      setUnsubscriber={setUnsubscriber}
                      subscribers={subscribers}
                      unSubscribers={unSubscribers}
                    />
                  </div>

                  <div
                    className="col-12 d-flex justify-content-end align-items-center"
                    style={{
                      paddingTop: "32px",
                      marginTop: "40px",
                      borderTop: "1px solid #c9c9c9",
                    }}
                  ></div>
                  <div className="col-12 d-flex justify-content-end align-items-center">
                    <Button
                      onClick={handleSubmit}
                      newClass={"submit-btn"}
                      btnName={"Submit"}
                      type={"button"}
                    />
                  </div>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}
export default connect(null, {
  getUserProfile,
  updatingSubscribersAndUnsubscribers,
})(UserSubscribed);
